/*
 * @Description: computer actions
 */
import { ActionTree, ActionContext } from 'vuex'
import { RootState } from '@/store'
import { Mutations } from './mutations'
import { MoocActionTypes } from './action-types'
import { MoocMutationTypes } from './mutation-types'
import { MoocState,ConfigState } from '@/constant/moocTupe'
type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<MoocState, RootState>, 'commit'>

export interface Actions {
  [MoocActionTypes.ACTION_MOOC_SETNAV](
    { commit }: AugmentedActionContext,
    navConfig: ConfigState
  ): void
  
}

export const actions: ActionTree<MoocState, RootState> & Actions = {
  //导航
  [MoocActionTypes.ACTION_MOOC_SETNAV](
  { commit }: AugmentedActionContext, navConfig: ConfigState) {
    commit(MoocMutationTypes.SET_MOOC_NAV, navConfig)
  },
  

}
